// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"71":"804a783f","276":"17c7f2e9","294":"7ac1d399","314":"77139afd","639":"20290e4d","817":"4663e447","924":"5b87038f"}[chunkId] + ".css";
};